<template>
  <VTooltip>
    <span class="badge badge-square badge-light-dark help-btn">i</span>

    <template #popper>
      <slot/>
    </template>
  </VTooltip>
</template>

<script>
export default {
  name: "HelpMessage"
}
</script>

<style>
.help-btn {
  margin: 0 0.5rem;
  cursor: pointer;
  height: 1rem !important;
  min-width: 1rem !important;
  font-weight: 500;
}
.v-popper {
  display: inline-block;
}
</style>
